import { useEffect, useState } from "react"
import footerConfig from "../data/footer-config.json"

interface FooterStats {
  volume: number
  activeTrades: number
  holders: number
  tokenPrice: number
  lastTrade: string
  timeAgo: number
  liveBets: number
  inTheArena: number
}

export function useFooterStats() {
  const [stats, setStats] = useState<FooterStats>(footerConfig.stats.defaults)

  // Simulate small live updates – placeholder until realtime data wired up
  useEffect(() => {
    const interval = setInterval(() => {
      setStats((prev) => ({
        ...prev,
        volume: prev.volume + Math.floor(Math.random() * 1_000),
        activeTrades: Math.max(prev.activeTrades + Math.floor(Math.random() * 3) - 1, 0),
        timeAgo: Math.floor(Math.random() * 60) + 1,
      }))
    }, 3_000)

    return () => clearInterval(interval)
  }, [])

  return { stats, setStats }
}

export function formatCount(num: number) {
  if (num >= 1_000_000) return `${Number((num / 1_000_000).toFixed(1))}M`
  if (num >= 1_000) return `${Number((num / 1_000).toFixed(1))}K`
  return num.toString()
}

export function formatMarketCap(cap: number) {
  const stripZeros = (s: string) => s.replace(/(\.\d*?[1-9])0+$|\.0+$/, "$1")
  if (cap >= 1_000_000_000) return `$${stripZeros((cap / 1_000_000_000).toFixed(2))}B`
  if (cap >= 1_000_000) return `$${stripZeros((cap / 1_000_000).toFixed(2))}M`
  if (cap >= 1_000) return `$${stripZeros((cap / 1_000).toFixed(1))}K`
  return `$${stripZeros(cap.toFixed(2))}`
}

export function truncateTitle(title: string, maxLength = 27) {
  return title.length > maxLength ? `${title.slice(0, maxLength)}...` : title
}
